import React from "react";

/**
 * Tabs Component
 * Reusable tabs with consistent styling matching original TabComponent.css
 * 
 * @param {Array} tabs - Array of tab labels
 * @param {string} activeTab - Currently active tab
 * @param {function} onChange - Tab change handler
 * @param {string} className - Additional classes
 */
const Tabs = ({ tabs, activeTab, onChange, className = "" }) => {
  return (
    <div className={`w-full h-[2.313rem] rounded-t-[0.75rem] flex border-b-0 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onChange(tab)}
          className={`flex-1 font-roboto font-medium text-center transition-colors border-0 ${
            activeTab === tab
              ? "text-[#3901ff] text-base underline decoration-[0.087rem] decoration-[#3901ff] underline-offset-[0.313rem] bg-white"
              : "text-[#2b2b2b] text-base leading-[0.688rem] bg-white"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
